import { SESSION_ACTIVE_WINDOW_MS } from '@sharedlib/common/session-activity';

export class Session {
  id: string;
  accountId: string;
  // Nullable at this boundary only: during a rolling deploy an accounts replica on the old image
  // answers without these fields, and `new Date(undefined)` renders as an empty label.
  recentActivity: Date | null;
  signedInAt: Date | null;
  os: string;
  location: string;
  browser: string;
  ipAddress: string | null;
  current: boolean;
  active: boolean;

  constructor(session) {
    this.id = session.id;
    this.accountId = session.accountId;
    this.recentActivity = session.recentActivity ? new Date(session.recentActivity) : null;
    this.signedInAt = session.signedInAt ? new Date(session.signedInAt) : null;
    this.os = session.os;
    this.location = session.location;
    this.browser = session.browser;
    this.ipAddress = session.ipAddress ?? null;
    this.current = session.current;
    // The session making this very request is active by definition, whatever its last report says.
    this.active =
      this.current ||
      (this.recentActivity !== null && this.recentActivity.getTime() + SESSION_ACTIVE_WINDOW_MS >= Date.now());
  }
}
